import React from 'react';

/* bleibt beim horizontalen Scrollen am linken Rand stehen, sobald die
   Namensspalte weggescrollt ist (siehe .calendar-row-label in theme.css) */
const CalendarRowLabel = (props) => {
  return (
      <div className="calendar-row-label">
        <div className="calendar-row-label__bar">
          <span className="calendar-row-label__text">{props.label}</span>
        </div>
      </div>
  );
};

export default CalendarRowLabel;
